(function(){
  function run(){
    var root=document.querySelector('.snug-about'); if(!root) return;
    // VIDEO: hover-play (desktop) + in-view autoplay (mobile) — always on
    var vids=root.querySelectorAll('.sa-vid');
    for(var i=0;i<vids.length;i++){(function(v){
      v.addEventListener('mouseenter',function(){var p=v.play();if(p&&p.catch)p.catch(function(){});});
      v.addEventListener('mouseleave',function(){v.pause();});
    })(vids[i]);}
    if('IntersectionObserver' in window){
      var vio=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){var p=e.target.play();if(p&&p.catch)p.catch(function(){});}else{e.target.pause();}});},{threshold:0.55});
      for(var n=0;n<vids.length;n++){vio.observe(vids[n]);}
    }
    // REVEAL animations — skip if user prefers reduced motion
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches){return;}
    var sel=['.sa-hero .sa-kicker','.sa-hero__title','.sa-hero__sub','.sa-manifesto__lead','.sa-manifesto__sign','.sa-tl__head','.sa-tl__intro','.sa-tl__item','.sa-rev__head','.sa-rev__sub','.sa-rev__badge','.sa-revc','.sa-show__head','.sa-show__sub','.sa-show__grid img','.sa-loc__head','.sa-loc__card','.sa-stat','.sa-row__media','.sa-row__text','.sa-values p','.sa-contact','.sa-cta h2','.sa-cta__btn'].join(',');
    var els=root.querySelectorAll(sel);
    for(var j=0;j<els.length;j++){els[j].classList.add('sa-reveal');}
    if(!('IntersectionObserver' in window)){for(var k=0;k<els.length;k++){els[k].classList.add('in');}return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:0.12,rootMargin:'0px 0px -7% 0px'});
    for(var m=0;m<els.length;m++){io.observe(els[m]);}
  }
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
})();
